import {
  ExchangeRateFilter,
  PagedClientRecommendedRateResponse,
} from '@acme/domains';
import {
  Spinner,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeadCell,
  TableRow,
} from 'flowbite-react';
import { formatDate } from '../lib';
import { NoData } from './noData/noData';
import { useEffect, useState } from 'react';
import { EFilterMode, Filter } from './filter';

interface RecommendedExchangeRatesProps {
  loader: (
    filter: ExchangeRateFilter
  ) => Promise<PagedClientRecommendedRateResponse | undefined>;
  loading?: boolean;
}

export const RecommendedExchangeRates = ({
  loading,
  loader,
}: RecommendedExchangeRatesProps) => {
  const [data, setData] = useState<PagedClientRecommendedRateResponse | null>();
  const [filter, setFilter] = useState({});
  useEffect(() => {
    const loadItems = async () => {
      const response = await loader({
        ...filter,
      });
      setData(response);
    };
    loadItems();
  }, [filter]);
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex items-center justify-center py-8">
          <Spinner size="lg" />
          <span className="ml-3 text-gray-600">Загрузка курсов валют...</span>
        </div>
      </div>
    );
  }
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="flex flex-col px-4 gap-2">
        <Filter mode={EFilterMode.CURRENCY_PAIR} onChange={setFilter} />
      </div>

      {data?.items?.length === 0 ? (
        <NoData
          title={
            Object.keys(filter).length === 0
              ? 'Курсы пока не установлены'
              : 'Курсы по заданным условиям не найдены'
          }
        />
      ) : (
        <div className="overflow-x-auto">
          <Table hoverable>
            <TableHead>
              <TableRow>
                <TableHeadCell>Валютная пара</TableHeadCell>
                <TableHeadCell>Покупка</TableHeadCell>
                <TableHeadCell>Продажа</TableHeadCell>
                <TableHeadCell>Время обновления</TableHeadCell>
              </TableRow>
            </TableHead>

            <TableBody className="divide-y">
              {data?.items?.map((rate) => (
                <TableRow
                  key={rate.id}
                  className="text-sm font-normal text-gray-900 dark:text-white"
                >
                  <TableCell className="whitespace-nowrap">
                    {`${rate.cryptoCurrency?.code} > ${rate.currency?.code}`}
                  </TableCell>
                  <TableCell className="whitespace-nowrap">
                    {rate.buyPrice}
                  </TableCell>
                  <TableCell className="truncate">{rate.sellPrice}</TableCell>
                  <TableCell className="truncate">
                    {formatDate(rate.updateAt)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
};
